import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';
import { NoResultsLabelComponent } from './no-results-label.component';

const lazyTranslationloader = ['en_au', 'es', 'en_us'].reduce(
  (acc: { [key: string]: () => Promise<any> }, lang) => {
    acc[lang] = () => import(`./i18n/${lang}.json`);

    return acc;
  },
  {}
);

@NgModule({
  declarations: [NoResultsLabelComponent],
  imports: [CommonModule, TranslocoDirective],
  exports: [NoResultsLabelComponent],
  providers: [
    provideTranslocoScope({
      scope: 'noResults',
      loader: lazyTranslationloader,
    }),
  ],
})
export class NoResultsLabelModule {}
